export default __webpack_public_path__ + "static/media/favicon.ca35646e.png";